export default __webpack_public_path__ + "static/image 50-97345104eff4ad9d431f86a68db14b9d.png";